import { Button } from "@kalodata/kds-design";
import { IconLinePlus } from "@kalodata/kds-design-icons";
import { themeAtom } from "@src/jotai/theme";
import { TestId } from "@shared/testIds";
import { useAtomValue } from "jotai";
import { Trans } from "react-i18next";
import { twMerge } from "tailwind-merge";

export type PostVideoButtonVariant = "floating" | "reverse";

const variantClassName: Record<PostVideoButtonVariant, string> = {
  floating: "bg-kds-bg-element text-kds-fg border border-kds-border-solid",
  reverse:
    "h-[40px] bg-kds-dark-reverse text-kds-light-reverse shadow-none hover:bg-(--palette-slate-11) hover:text-kds-light-reverse",
};

const reverseShadowClassName = {
  light: "![box-shadow:0px_4px_24px_0px_var(--palette-base-black-alpha-5)]",
  dark: "![box-shadow:0px_4px_24px_0px_var(--kds-shadow-soft)]",
} as const;

export interface PostVideoButtonProps {
  onClick?: () => void;
  disabled?: boolean;
  variant?: PostVideoButtonVariant;
  withShadow?: boolean;
  className?: string;
  "data-testid"?: string;
}

export const PostVideoButton = ({
  onClick,
  disabled,
  variant = "floating",
  withShadow = false,
  className,
  "data-testid": dataTestId = TestId.SocialPublisherPostVideo,
}: PostVideoButtonProps) => {
  const isDark = useAtomValue(themeAtom) === "dark";

  return (
    <Button
      type={variant === "reverse" ? "reverse" : undefined}
      size="lg"
      iconPlacement="start"
      icon={<IconLinePlus size={20} />}
      disabled={disabled}
      className={twMerge(
        variantClassName[variant],
        variant === "reverse" && withShadow && reverseShadowClassName[isDark ? "dark" : "light"],
        className,
      )}
      data-testid={dataTestId}
      onClick={onClick}
    >
      <Trans>Post video</Trans>
    </Button>
  );
};
